module.exports = __webpack_public_path__ + "media/images/icon-check-8f90caf1e5a415fa15b1dc25c36c1af3.svg";